<div class="slider-form-container">
  <!-- Fixed Header -->
  <div class="slider-form-header">
    <div class="form-banner">
      <img class="ban1" src="assets/images/formbanner1.svg" alt="Form Banner" />

      <div class="banner-text">
        <h2 class="form-title">Edit User</h2>
        <p>Update Team Member</p>
      </div>
      <img class="ban2" src="assets/images/formbanner2.svg" alt="Form Banner" />
      <button (click)="onClose()" class="close-button" aria-label="Close">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
  <!-- Scrollable Content -->
  <div class="slider-form-content-wrapper">
    <div class="slider-form-content">
      <form (ngSubmit)="onSubmit()" class="edit-people-form">
        <div class="form_field_wrapper">
          <input
            type="text"
            name="firstName"
            required
            placeholder=" "
            maxlength="60"
            class="form-control"
            [formControl]="firstNameControl"
            appPreventLeadingSpace
          />
          <label class="floating_label">First Name *</label>
          @if (firstNameControl.hasError('required') && firstNameControl.touched) {
          <div class="mat-error">Please enter the First Name</div>
          }
        </div>

        <div class="form_field_wrapper">
          <input
            type="text"
            name="lastName"
            required
            placeholder=" "
            maxlength="60"
            class="form-control"
            [formControl]="lastNameControl"
            appPreventLeadingSpace
          />
          <label class="floating_label">Last Name *</label>
          @if (lastNameControl.hasError('required') && lastNameControl.touched) {
          <div class="mat-error">Please enter the Last Name</div>
          }
        </div>

        <div class="form_field_wrapper">
          <input
            readonly
            type="email"
            name="email"
            required
            placeholder=" "
            maxlength="100"
            class="form-control"
            [formControl]="emailControl"
            [class.error]="emailControl.hasError('serverError')"
            appPreventLeadingSpace
          />
          <label class="floating_label">Email *</label>
          @if (emailControl.hasError('required') && emailControl.touched) {
            <div class="mat-error">
            Please enter the Email
          </div>
          }
          @if (emailControl.hasError('email') && emailControl.touched) {
            <div class="mat-error">
            Please enter a valid Email
          </div>
          }
          @if (emailControl.hasError('maxlength') && emailControl.touched) {
            <div class="mat-error">
            Email must be at most 100 characters
          </div>
          }
          @if (emailControl.hasError('serverError') && emailControl.touched) {
            <div class="mat-error">
            {{ getEmailErrorMessage() }}
          </div>
          }
        </div>

        <div class="form-row full-width">
          <div class="form_field_wrapper half-width">
            <input
              type="tel"
              name="phone"
              placeholder=" "
              maxlength="16"
              class="form-control"
              [formControl]="phoneControl"
              [class.error]="phoneControl.hasError('serverError')"
              appPreventLeadingSpace
            />
            <label class="floating_label">Phone</label>
            @if (phoneControl.hasError('pattern') && phoneControl.touched) {
              <div class="mat-error">
              Please enter a valid Phone Number (e.g. +1234567890)
            </div>
            }
            @if (phoneControl.hasError('minlength') && phoneControl.touched) {
              <div class="mat-error">
              Phone number must be at least 10 digits
            </div>
            }
            @if (phoneControl.hasError('maxlength') && phoneControl.touched) {
              <div class="mat-error">
              Phone number must be at most 15 digits
            </div>
            }
            @if (phoneControl.hasError('serverError') && phoneControl.touched) {
              <div class="mat-error">
              {{ getPhoneErrorMessage() }}
            </div>
            }
          </div>

          <div class="form_field_wrapper half-width">
            <div class="date_wrap">
              <input
                matInput
                [matDatepicker]="dobPicker"
                [formControl]="dobControl"
                [max]="maxDate"
                name="dateOfBirth"
                placeholder=" "
                class="form-control"
                (click)="dobPicker.open()"
              />
              <mat-datepicker-toggle matSuffix [for]="dobPicker">
                <i matDatepickerToggleIcon class="wl_icon_calendar"></i>
              </mat-datepicker-toggle>
              <mat-datepicker #dobPicker></mat-datepicker>
            </div>
            <label class="floating_label">Date of Birth</label>
            @if (dobControl.hasError('minAge') && dobControl.touched) {
            <div class="mat-error">Person must be at least 16 years old</div>
            } @if (dobControl.hasError('maxAge') && dobControl.touched) {
            <div class="mat-error">Please enter a valid date of birth</div>
            }
          </div>
        </div>

        <!-- <div class="form_field_wrapper">
          <ng-select
            [items]="companies()"
            bindLabel="name"
            bindValue="_id"
            [formControl]="companyControl"
            name="company"
            class="modal-ng-select"
            [searchable]="true"
            [clearable]="true"
          >
          </ng-select>
          <label class="floating_label">Select Company</label>
        </div> -->

        <div class="form-row full-width">
          <div class="form_field_wrapper half-width">
            <input
              type="text"
              name="jobTitle"
              required
              placeholder=" "
              maxlength="100"
              class="form-control"
              [formControl]="jobTitleControl"
              appPreventLeadingSpace
            />
            <label class="floating_label">Job Title *</label>
             @if (jobTitleControl.hasError('required') && jobTitleControl.touched) {
              <div class="mat-error">
              Please enter the Job Title
            </div>
            }
            @if (jobTitleControl.hasError('minlength') && jobTitleControl.touched) {
              <div class="mat-error">
              Job Title must be at least 2 characters
            </div>
            }
          </div>

          <div class="form_field_wrapper half-width">
            <ng-select
              [items]="jobRoles()"
              bindLabel="jobrole"
              bindValue="_id"
              [formControl]="jobRoleControl"
              name="jobRole"
              class="modal-ng-select"
              [searchable]="true"
              [clearable]="true"
            >
              <ng-template ng-option-tmp let-item="item">
                <div class="template-option">
                  <span class="role-name">{{ item.jobrole }}</span>
                </div>
              </ng-template>
              <ng-template ng-notfound-tmp>
                <div class="no-results">
                  <mat-icon>search_off</mat-icon>
                  <p>No job roles found</p>
                </div>
              </ng-template>
            </ng-select>
            <label class="floating_label">Job Role *</label>
            @if (jobRoleControl.hasError('required') && jobRoleControl.touched)
            {
            <div class="mat-error">Please select Job Role</div>
            }
          </div>
        </div>

        <div class="form_field_wrapper full-width">
          <textarea
            name="address"
            rows="3"
            maxlength="250"
            placeholder=" "
            class="form-control"
            [formControl]="addressControl"
          ></textarea>
          <label class="floating_label">Address</label>
           @if (addressControl.hasError('maxlength') && addressControl.touched) {
            <div class="mat-error">
            Address must be at most 250 characters
          </div>
          }
        </div>

        <div class="form-row full-width">
          <div class="form_field_wrapper half-width">
            <ng-select
              [items]="timezoneOptions"
              bindLabel="label"
              bindValue="value"
              [formControl]="timezoneControl"
              name="timezone"
              class="modal-ng-select"
              [searchable]="true"
              [clearable]="true"
            >
            </ng-select>
            <label class="floating_label">Timezone *</label>
            @if (timezoneControl.hasError('required') &&
            timezoneControl.touched) {
            <div class="mat-error">Please select Timezone</div>
            }
          </div>

          <div class="form_field_wrapper half-width">
            <ng-select
              [items]="countryOptions"
              bindLabel="name"
              bindValue="code"
              [formControl]="countryControl"
              name="country"
              class="modal-ng-select"
              [searchable]="false"
              [clearable]="true"
            >
              <ng-template ng-label-tmp let-item="item">
                <div class="country-option">
                  <span>{{ item.name }}</span>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item">
                <div class="country-option">
                  <span>{{ item.name }}</span>
                </div>
              </ng-template>
            </ng-select>
            <label class="floating_label">Country</label>
          </div>
        </div>

        <div class="form-row full-width">
          <div class="form_field_wrapper half-width">
            <ng-select
              [items]="homeTeams()"
              bindLabel="teamName"
              bindValue="_id"
              [formControl]="homeTeamControl"
              name="homeTeam"
              class="modal-ng-select"
              [searchable]="true"
              [clearable]="true"
            >
              <ng-template ng-option-tmp let-item="item">
                <div class="template-option">
                  <span class="team-name">{{ item.teamName }}</span>
                </div>
              </ng-template>
              <ng-template ng-notfound-tmp>
                <div class="no-results">
                  <mat-icon>search_off</mat-icon>
                  <p>No teams found</p>
                </div>
              </ng-template>
            </ng-select>
            <label class="floating_label">Home Team *</label>
            @if (homeTeamControl.hasError('required') &&
            homeTeamControl.touched) {
            <div class="mat-error">Please select Home Team</div>
            }
          </div>

          <div class="form_field_wrapper half-width">
            <ng-select
              [items]="managers()"
              bindLabel="name"
              bindValue="_id"
              [formControl]="managerControl"
              name="manager"
              class="modal-ng-select"
              [searchable]="true"
              [clearable]="true"
            >
              <ng-template ng-option-tmp let-item="item">
                <div class="template-option">
                  @if (item.avatar) {
                  <img [src]="item.avatar" class="user-avatar" />
                  }
                  <span class="user-name">{{ item.name }}</span>
                </div>
              </ng-template>
              <ng-template ng-notfound-tmp>
                <div class="no-results">
                  <mat-icon>search_off</mat-icon>
                  <p>No managers found</p>
                </div>
              </ng-template>
            </ng-select>
            <label class="floating_label">Select Manager *</label>
            @if (managerControl.hasError('required') && managerControl.touched) {
            <div class="mat-error">Please select Manager</div>
            }
          </div>
        </div>

        <div class="form-row full-width">
          <div class="form_field_wrapper half-width">
            <ng-select
              [items]="homeTeams()"
              bindLabel="teamName"
              bindValue="_id"
              [formControl]="actualTeamControl"
              name="actualTeam"
              class="modal-ng-select"
              [searchable]="true"
              [clearable]="true"
            >
              <ng-template ng-option-tmp let-item="item">
                <div class="template-option">
                  <span class="team-name">{{ item.teamName }}</span>
                </div>
              </ng-template>
              <ng-template ng-notfound-tmp>
                <div class="no-results">
                  <mat-icon>search_off</mat-icon>
                  <p>No teams found</p>
                </div>
              </ng-template>
            </ng-select>
            <label class="floating_label">Actual Team *</label>
            @if (actualTeamControl.hasError('required') &&
            actualTeamControl.touched) {
            <div class="mat-error">Please select Actual Team</div>
            }
          </div>

          <div class="form_field_wrapper half-width">
            <ng-select
              [items]="accessLevelOptions"
              bindLabel="accesslevel_name"
              bindValue="_id"
              [formControl]="accessLevelControl"
              name="accessLevel"
              class="modal-ng-select"
              [searchable]="false"
              [clearable]="true"
            >
            </ng-select>
            <label class="floating_label">Select Access Level *</label>
            @if (accessLevelControl.hasError('required') &&
            accessLevelControl.touched) {
            <div class="mat-error">Please select Access Level</div>
            }
          </div>
        </div>

        <div class="form-row full-width">
          <div class="form_field_wrapper full-width">
            <ng-select
              [items]="accessLevelTypeOptions"
              bindLabel="label"
              bindValue="value"
              [formControl]="accessLevelTypeControl"
              name="accessLevelType"
              class="modal-ng-select"
              [searchable]="false"
              [clearable]="true"
            >
            </ng-select>
            <label class="floating_label">Access Level Type *</label>
            @if (accessLevelTypeControl.hasError('required') &&
            accessLevelTypeControl.touched) {
            <div class="mat-error">Please select Access Level Type</div>
            }
          </div>
        </div>

        <!-- Active Status Toggle -->
        <!-- <div class="form_field_wrapper full-width">
          <div class="toggle-field">
            <div class="toggle-container">
              <label class="toggle-label">Active Status</label>
              <div class="toggle-wrapper">
                <button
                  type="button"
                  class="toggle-button"
                  [class.active]="isActiveControl.value"
                  (click)="toggleActiveStatus()"
                >
                  <span class="toggle-slider"></span>
                 
                </button>
                <span class="toggle-text">{{ isActiveControl.value ? 'Active' : 'Inactive' }}</span>
              </div>
            </div>
          </div>
        </div> -->

        <!-- <div class="form_field_wrapper full-width">
          <textarea
            name="description"
            rows="3"
            maxlength="500"
            placeholder=" "
            class="form-control"
            [formControl]="descriptionControl"
          ></textarea>
          <label class="floating_label">Description</label>
        </div> -->

        <div class="form_field_wrapper full-width">
          <textarea
            name="description"
            rows="3"
            maxlength="500"
            placeholder=" "
            class="form-control"
            [formControl]="descriptionControl"
          ></textarea>
          <label class="floating_label">Description</label>
          @if (descriptionControl.hasError('maxlength') && descriptionControl.touched) {
            <div class="mat-error">
            Description must be at most 500 characters
          </div>
          }
        </div>
      </form>
    </div>
  </div>

  <!-- Fixed Actions -->
  <div class="slider-form-actions">
    <button
      type="submit"
      (click)="onSubmit()"
      [disabled]="!isFormValid() || isLoading || !hasChanges()"
      class="btn-save"
    >Save User
      <div class="button-content">
        @if (isLoading) {
          <app-spinner [size]="20"></app-spinner>
        }
      </div>
    </button>
    <button type="button" (click)="onClose()" class="btn-cancel">
      <span>Cancel</span>
    </button>
  </div>
</div>
